import React, {ReactElement, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import Button from '../../../../incase-domain/components/button/Button';
import DropdownMenuCompact from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Label from '../../../../incase-domain/components/label/Label';
import {IElementModal} from '../../../../incase-domain/elements/modal';
import {ISlide} from '../../../../incase-domain/slide';
import {selectedPresentationSelector} from '../../../../store/selectors/presentation.selectors';

interface SlideAsContentProps {
    selectedSlideId: string;
    highlightedElementChangeHandler: {single: (field: keyof IElementModal, value: unknown) => void};
    fixed?: boolean;
}

function SlideAsContent(props: SlideAsContentProps): ReactElement {
    const {selectedSlideId, highlightedElementChangeHandler, fixed = true} = props;
    const {t} = useTranslation();

    const allSlides = useSelector(selectedPresentationSelector).slides;
    const selectSlides = useMemo(
        () =>
            allSlides.map((slide: ISlide) => ({
                label: slide.name,
                value: slide._id,
            })),
        [allSlides]
    );

    return (
        <>
            <Label>{t('designSidepanel.setModalContent')}</Label>
            <DropdownMenuCompact
                width="full"
                className="c-sidepanel__dropdown"
                fixed={fixed ? 'bottom' : undefined}
                items={[
                    selectSlides.map((el) => ({
                        label: el.label,
                        onClick: () => highlightedElementChangeHandler.single('selectedSlideId', el.value),
                    })),
                ]}
            >
                <Button fullWidth size="xs" trailing="solar:alt-arrow-down-linear" variant="soft" className="c-sidepanel__dropdown_button">
                    {selectSlides.find((item) => item.value === selectedSlideId)?.label || t('designSidepanel.selectSlide')}
                </Button>
            </DropdownMenuCompact>
        </>
    );
}

export default SlideAsContent;
